import { render, staticRenderFns } from "./QuestionCategoryEdit.vue?vue&type=template&id=03257c90&scoped=true&"
import script from "./QuestionCategoryEdit.vue?vue&type=script&lang=js&"
export * from "./QuestionCategoryEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03257c90",
  null
  
)

export default component.exports